/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var proto_types_action_pb = require('../../proto/types/action_pb.js');
var proto_types_endorsement_pb = require('../../proto/types/endorsement_pb.js');
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.exportSymbol('proto.iotextypes.AccountMeta', null, global);
goog.exportSymbol('proto.iotextypes.Block', null, global);
goog.exportSymbol('proto.iotextypes.BlockBody', null, global);
goog.exportSymbol('proto.iotextypes.BlockFooter', null, global);
goog.exportSymbol('proto.iotextypes.BlockHeader', null, global);
goog.exportSymbol('proto.iotextypes.BlockHeaderCore', null, global);
goog.exportSymbol('proto.iotextypes.BlockIdentifier', null, global);
goog.exportSymbol('proto.iotextypes.BlockMeta', null, global);
goog.exportSymbol('proto.iotextypes.BlockStore', null, global);
goog.exportSymbol('proto.iotextypes.BlockStores', null, global);
goog.exportSymbol('proto.iotextypes.ChainMeta', null, global);
goog.exportSymbol('proto.iotextypes.EpochData', null, global);
goog.exportSymbol('proto.iotextypes.Receipts', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iotextypes.BlockHeader = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iotextypes.BlockHeader, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.iotextypes.BlockHeader.displayName = 'proto.iotextypes.BlockHeader';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iotextypes.BlockHeader.prototype.toObject = function(opt_includeInstance) {
  return proto.iotextypes.BlockHeader.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iotextypes.BlockHeader} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockHeader.toObject = function(includeInstance, msg) {
  var f, obj = {
    core: (f = msg.getCore()) && proto.iotextypes.BlockHeaderCore.toObject(includeInstance, f),
    producerpubkey: msg.getProducerpubkey_asB64(),
    signature: msg.getSignature_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iotextypes.BlockHeader}
 */
proto.iotextypes.BlockHeader.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iotextypes.BlockHeader;
  return proto.iotextypes.BlockHeader.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iotextypes.BlockHeader} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iotextypes.BlockHeader}
 */
proto.iotextypes.BlockHeader.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.iotextypes.BlockHeaderCore;
      reader.readMessage(value,proto.iotextypes.BlockHeaderCore.deserializeBinaryFromReader);
      msg.setCore(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setProducerpubkey(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSignature(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockHeader.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iotextypes.BlockHeader.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iotextypes.BlockHeader} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockHeader.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCore();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.iotextypes.BlockHeaderCore.serializeBinaryToWriter
    );
  }
  f = message.getProducerpubkey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getSignature_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * optional BlockHeaderCore core = 1;
 * @return {?proto.iotextypes.BlockHeaderCore}
 */
proto.iotextypes.BlockHeader.prototype.getCore = function() {
  return /** @type{?proto.iotextypes.BlockHeaderCore} */ (
    jspb.Message.getWrapperField(this, proto.iotextypes.BlockHeaderCore, 1));
};


/** @param {?proto.iotextypes.BlockHeaderCore|undefined} value */
proto.iotextypes.BlockHeader.prototype.setCore = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.iotextypes.BlockHeader.prototype.clearCore = function() {
  this.setCore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.iotextypes.BlockHeader.prototype.hasCore = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes producerPubkey = 2;
 * @return {string}
 */
proto.iotextypes.BlockHeader.prototype.getProducerpubkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes producerPubkey = 2;
 * This is a type-conversion wrapper around `getProducerpubkey()`
 * @return {string}
 */
proto.iotextypes.BlockHeader.prototype.getProducerpubkey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getProducerpubkey()));
};


/**
 * optional bytes producerPubkey = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getProducerpubkey()`
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockHeader.prototype.getProducerpubkey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getProducerpubkey()));
};


/** @param {!(string|Uint8Array)} value */
proto.iotextypes.BlockHeader.prototype.setProducerpubkey = function(value) {
  jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional bytes signature = 3;
 * @return {string}
 */
proto.iotextypes.BlockHeader.prototype.getSignature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes signature = 3;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */
proto.iotextypes.BlockHeader.prototype.getSignature_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSignature()));
};


/**
 * optional bytes signature = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockHeader.prototype.getSignature_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSignature()));
};


/** @param {!(string|Uint8Array)} value */
proto.iotextypes.BlockHeader.prototype.setSignature = function(value) {
  jspb.Message.setProto3BytesField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iotextypes.BlockHeaderCore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iotextypes.BlockHeaderCore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.iotextypes.BlockHeaderCore.displayName = 'proto.iotextypes.BlockHeaderCore';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iotextypes.BlockHeaderCore.prototype.toObject = function(opt_includeInstance) {
  return proto.iotextypes.BlockHeaderCore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iotextypes.BlockHeaderCore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockHeaderCore.toObject = function(includeInstance, msg) {
  var f, obj = {
    version: jspb.Message.getFieldWithDefault(msg, 1, 0),
    height: jspb.Message.getFieldWithDefault(msg, 2, 0),
    timestamp: (f = msg.getTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    prevblockhash: msg.getPrevblockhash_asB64(),
    txroot: msg.getTxroot_asB64(),
    deltastatedigest: msg.getDeltastatedigest_asB64(),
    receiptroot: msg.getReceiptroot_asB64(),
    logsbloom: msg.getLogsbloom_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iotextypes.BlockHeaderCore}
 */
proto.iotextypes.BlockHeaderCore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iotextypes.BlockHeaderCore;
  return proto.iotextypes.BlockHeaderCore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iotextypes.BlockHeaderCore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iotextypes.BlockHeaderCore}
 */
proto.iotextypes.BlockHeaderCore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setHeight(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPrevblockhash(value);
      break;
    case 5:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setTxroot(value);
      break;
    case 6:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setDeltastatedigest(value);
      break;
    case 7:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setReceiptroot(value);
      break;
    case 8:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setLogsbloom(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockHeaderCore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iotextypes.BlockHeaderCore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iotextypes.BlockHeaderCore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockHeaderCore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPrevblockhash_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = message.getTxroot_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      5,
      f
    );
  }
  f = message.getDeltastatedigest_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      6,
      f
    );
  }
  f = message.getReceiptroot_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      7,
      f
    );
  }
  f = message.getLogsbloom_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      8,
      f
    );
  }
};


/**
 * optional uint32 version = 1;
 * @return {number}
 */
proto.iotextypes.BlockHeaderCore.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.iotextypes.BlockHeaderCore.prototype.setVersion = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 height = 2;
 * @return {number}
 */
proto.iotextypes.BlockHeaderCore.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.iotextypes.BlockHeaderCore.prototype.setHeight = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp timestamp = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.iotextypes.BlockHeaderCore.prototype.getTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.iotextypes.BlockHeaderCore.prototype.setTimestamp = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.iotextypes.BlockHeaderCore.prototype.clearTimestamp = function() {
  this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.iotextypes.BlockHeaderCore.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bytes prevBlockHash = 4;
 * @return {string}
 */
proto.iotextypes.BlockHeaderCore.prototype.getPrevblockhash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes prevBlockHash = 4;
 * This is a type-conversion wrapper around `getPrevblockhash()`
 * @return {string}
 */
proto.iotextypes.BlockHeaderCore.prototype.getPrevblockhash_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPrevblockhash()));
};


/**
 * optional bytes prevBlockHash = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPrevblockhash()`
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockHeaderCore.prototype.getPrevblockhash_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPrevblockhash()));
};


/** @param {!(string|Uint8Array)} value */
proto.iotextypes.BlockHeaderCore.prototype.setPrevblockhash = function(value) {
  jspb.Message.setProto3BytesField(this, 4, value);
};


/**
 * optional bytes txRoot = 5;
 * @return {string}
 */
proto.iotextypes.BlockHeaderCore.prototype.getTxroot = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * optional bytes txRoot = 5;
 * This is a type-conversion wrapper around `getTxroot()`
 * @return {string}
 */
proto.iotextypes.BlockHeaderCore.prototype.getTxroot_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getTxroot()));
};


/**
 * optional bytes txRoot = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTxroot()`
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockHeaderCore.prototype.getTxroot_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getTxroot()));
};


/** @param {!(string|Uint8Array)} value */
proto.iotextypes.BlockHeaderCore.prototype.setTxroot = function(value) {
  jspb.Message.setProto3BytesField(this, 5, value);
};


/**
 * optional bytes deltaStateDigest = 6;
 * @return {string}
 */
proto.iotextypes.BlockHeaderCore.prototype.getDeltastatedigest = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * optional bytes deltaStateDigest = 6;
 * This is a type-conversion wrapper around `getDeltastatedigest()`
 * @return {string}
 */
proto.iotextypes.BlockHeaderCore.prototype.getDeltastatedigest_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getDeltastatedigest()));
};


/**
 * optional bytes deltaStateDigest = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDeltastatedigest()`
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockHeaderCore.prototype.getDeltastatedigest_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getDeltastatedigest()));
};


/** @param {!(string|Uint8Array)} value */
proto.iotextypes.BlockHeaderCore.prototype.setDeltastatedigest = function(value) {
  jspb.Message.setProto3BytesField(this, 6, value);
};


/**
 * optional bytes receiptRoot = 7;
 * @return {string}
 */
proto.iotextypes.BlockHeaderCore.prototype.getReceiptroot = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * optional bytes receiptRoot = 7;
 * This is a type-conversion wrapper around `getReceiptroot()`
 * @return {string}
 */
proto.iotextypes.BlockHeaderCore.prototype.getReceiptroot_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getReceiptroot()));
};


/**
 * optional bytes receiptRoot = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getReceiptroot()`
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockHeaderCore.prototype.getReceiptroot_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getReceiptroot()));
};


/** @param {!(string|Uint8Array)} value */
proto.iotextypes.BlockHeaderCore.prototype.setReceiptroot = function(value) {
  jspb.Message.setProto3BytesField(this, 7, value);
};


/**
 * optional bytes logsBloom = 8;
 * @return {string}
 */
proto.iotextypes.BlockHeaderCore.prototype.getLogsbloom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * optional bytes logsBloom = 8;
 * This is a type-conversion wrapper around `getLogsbloom()`
 * @return {string}
 */
proto.iotextypes.BlockHeaderCore.prototype.getLogsbloom_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getLogsbloom()));
};


/**
 * optional bytes logsBloom = 8;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getLogsbloom()`
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockHeaderCore.prototype.getLogsbloom_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getLogsbloom()));
};


/** @param {!(string|Uint8Array)} value */
proto.iotextypes.BlockHeaderCore.prototype.setLogsbloom = function(value) {
  jspb.Message.setProto3BytesField(this, 8, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iotextypes.BlockFooter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.iotextypes.BlockFooter.repeatedFields_, null);
};
goog.inherits(proto.iotextypes.BlockFooter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.iotextypes.BlockFooter.displayName = 'proto.iotextypes.BlockFooter';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.iotextypes.BlockFooter.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iotextypes.BlockFooter.prototype.toObject = function(opt_includeInstance) {
  return proto.iotextypes.BlockFooter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iotextypes.BlockFooter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockFooter.toObject = function(includeInstance, msg) {
  var f, obj = {
    endorsementsList: jspb.Message.toObjectList(msg.getEndorsementsList(),
    proto_types_endorsement_pb.Endorsement.toObject, includeInstance),
    timestamp: (f = msg.getTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iotextypes.BlockFooter}
 */
proto.iotextypes.BlockFooter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iotextypes.BlockFooter;
  return proto.iotextypes.BlockFooter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iotextypes.BlockFooter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iotextypes.BlockFooter}
 */
proto.iotextypes.BlockFooter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_types_endorsement_pb.Endorsement;
      reader.readMessage(value,proto_types_endorsement_pb.Endorsement.deserializeBinaryFromReader);
      msg.addEndorsements(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockFooter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iotextypes.BlockFooter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iotextypes.BlockFooter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockFooter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndorsementsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_types_endorsement_pb.Endorsement.serializeBinaryToWriter
    );
  }
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Endorsement endorsements = 1;
 * @return {!Array<!proto.iotextypes.Endorsement>}
 */
proto.iotextypes.BlockFooter.prototype.getEndorsementsList = function() {
  return /** @type{!Array<!proto.iotextypes.Endorsement>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_types_endorsement_pb.Endorsement, 1));
};


/** @param {!Array<!proto.iotextypes.Endorsement>} value */
proto.iotextypes.BlockFooter.prototype.setEndorsementsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.iotextypes.Endorsement=} opt_value
 * @param {number=} opt_index
 * @return {!proto.iotextypes.Endorsement}
 */
proto.iotextypes.BlockFooter.prototype.addEndorsements = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.iotextypes.Endorsement, opt_index);
};


proto.iotextypes.BlockFooter.prototype.clearEndorsementsList = function() {
  this.setEndorsementsList([]);
};


/**
 * optional google.protobuf.Timestamp timestamp = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.iotextypes.BlockFooter.prototype.getTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.iotextypes.BlockFooter.prototype.setTimestamp = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.iotextypes.BlockFooter.prototype.clearTimestamp = function() {
  this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.iotextypes.BlockFooter.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iotextypes.BlockBody = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.iotextypes.BlockBody.repeatedFields_, null);
};
goog.inherits(proto.iotextypes.BlockBody, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.iotextypes.BlockBody.displayName = 'proto.iotextypes.BlockBody';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.iotextypes.BlockBody.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iotextypes.BlockBody.prototype.toObject = function(opt_includeInstance) {
  return proto.iotextypes.BlockBody.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iotextypes.BlockBody} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockBody.toObject = function(includeInstance, msg) {
  var f, obj = {
    actionsList: jspb.Message.toObjectList(msg.getActionsList(),
    proto_types_action_pb.Action.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iotextypes.BlockBody}
 */
proto.iotextypes.BlockBody.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iotextypes.BlockBody;
  return proto.iotextypes.BlockBody.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iotextypes.BlockBody} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iotextypes.BlockBody}
 */
proto.iotextypes.BlockBody.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_types_action_pb.Action;
      reader.readMessage(value,proto_types_action_pb.Action.deserializeBinaryFromReader);
      msg.addActions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockBody.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iotextypes.BlockBody.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iotextypes.BlockBody} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockBody.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_types_action_pb.Action.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Action actions = 1;
 * @return {!Array<!proto.iotextypes.Action>}
 */
proto.iotextypes.BlockBody.prototype.getActionsList = function() {
  return /** @type{!Array<!proto.iotextypes.Action>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_types_action_pb.Action, 1));
};


/** @param {!Array<!proto.iotextypes.Action>} value */
proto.iotextypes.BlockBody.prototype.setActionsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.iotextypes.Action=} opt_value
 * @param {number=} opt_index
 * @return {!proto.iotextypes.Action}
 */
proto.iotextypes.BlockBody.prototype.addActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.iotextypes.Action, opt_index);
};


proto.iotextypes.BlockBody.prototype.clearActionsList = function() {
  this.setActionsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iotextypes.Block = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iotextypes.Block, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.iotextypes.Block.displayName = 'proto.iotextypes.Block';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iotextypes.Block.prototype.toObject = function(opt_includeInstance) {
  return proto.iotextypes.Block.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iotextypes.Block} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.Block.toObject = function(includeInstance, msg) {
  var f, obj = {
    header: (f = msg.getHeader()) && proto.iotextypes.BlockHeader.toObject(includeInstance, f),
    body: (f = msg.getBody()) && proto.iotextypes.BlockBody.toObject(includeInstance, f),
    footer: (f = msg.getFooter()) && proto.iotextypes.BlockFooter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iotextypes.Block}
 */
proto.iotextypes.Block.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iotextypes.Block;
  return proto.iotextypes.Block.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iotextypes.Block} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iotextypes.Block}
 */
proto.iotextypes.Block.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.iotextypes.BlockHeader;
      reader.readMessage(value,proto.iotextypes.BlockHeader.deserializeBinaryFromReader);
      msg.setHeader(value);
      break;
    case 2:
      var value = new proto.iotextypes.BlockBody;
      reader.readMessage(value,proto.iotextypes.BlockBody.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 3:
      var value = new proto.iotextypes.BlockFooter;
      reader.readMessage(value,proto.iotextypes.BlockFooter.deserializeBinaryFromReader);
      msg.setFooter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iotextypes.Block.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iotextypes.Block.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iotextypes.Block} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.Block.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHeader();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.iotextypes.BlockHeader.serializeBinaryToWriter
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.iotextypes.BlockBody.serializeBinaryToWriter
    );
  }
  f = message.getFooter();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.iotextypes.BlockFooter.serializeBinaryToWriter
    );
  }
};


/**
 * optional BlockHeader header = 1;
 * @return {?proto.iotextypes.BlockHeader}
 */
proto.iotextypes.Block.prototype.getHeader = function() {
  return /** @type{?proto.iotextypes.BlockHeader} */ (
    jspb.Message.getWrapperField(this, proto.iotextypes.BlockHeader, 1));
};


/** @param {?proto.iotextypes.BlockHeader|undefined} value */
proto.iotextypes.Block.prototype.setHeader = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.iotextypes.Block.prototype.clearHeader = function() {
  this.setHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.iotextypes.Block.prototype.hasHeader = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BlockBody body = 2;
 * @return {?proto.iotextypes.BlockBody}
 */
proto.iotextypes.Block.prototype.getBody = function() {
  return /** @type{?proto.iotextypes.BlockBody} */ (
    jspb.Message.getWrapperField(this, proto.iotextypes.BlockBody, 2));
};


/** @param {?proto.iotextypes.BlockBody|undefined} value */
proto.iotextypes.Block.prototype.setBody = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.iotextypes.Block.prototype.clearBody = function() {
  this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.iotextypes.Block.prototype.hasBody = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional BlockFooter footer = 3;
 * @return {?proto.iotextypes.BlockFooter}
 */
proto.iotextypes.Block.prototype.getFooter = function() {
  return /** @type{?proto.iotextypes.BlockFooter} */ (
    jspb.Message.getWrapperField(this, proto.iotextypes.BlockFooter, 3));
};


/** @param {?proto.iotextypes.BlockFooter|undefined} value */
proto.iotextypes.Block.prototype.setFooter = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.iotextypes.Block.prototype.clearFooter = function() {
  this.setFooter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.iotextypes.Block.prototype.hasFooter = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iotextypes.Receipts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.iotextypes.Receipts.repeatedFields_, null);
};
goog.inherits(proto.iotextypes.Receipts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.iotextypes.Receipts.displayName = 'proto.iotextypes.Receipts';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.iotextypes.Receipts.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iotextypes.Receipts.prototype.toObject = function(opt_includeInstance) {
  return proto.iotextypes.Receipts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iotextypes.Receipts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.Receipts.toObject = function(includeInstance, msg) {
  var f, obj = {
    receiptsList: jspb.Message.toObjectList(msg.getReceiptsList(),
    proto_types_action_pb.Receipt.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iotextypes.Receipts}
 */
proto.iotextypes.Receipts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iotextypes.Receipts;
  return proto.iotextypes.Receipts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iotextypes.Receipts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iotextypes.Receipts}
 */
proto.iotextypes.Receipts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_types_action_pb.Receipt;
      reader.readMessage(value,proto_types_action_pb.Receipt.deserializeBinaryFromReader);
      msg.addReceipts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iotextypes.Receipts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iotextypes.Receipts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iotextypes.Receipts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.Receipts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceiptsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_types_action_pb.Receipt.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Receipt receipts = 1;
 * @return {!Array<!proto.iotextypes.Receipt>}
 */
proto.iotextypes.Receipts.prototype.getReceiptsList = function() {
  return /** @type{!Array<!proto.iotextypes.Receipt>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_types_action_pb.Receipt, 1));
};


/** @param {!Array<!proto.iotextypes.Receipt>} value */
proto.iotextypes.Receipts.prototype.setReceiptsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.iotextypes.Receipt=} opt_value
 * @param {number=} opt_index
 * @return {!proto.iotextypes.Receipt}
 */
proto.iotextypes.Receipts.prototype.addReceipts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.iotextypes.Receipt, opt_index);
};


proto.iotextypes.Receipts.prototype.clearReceiptsList = function() {
  this.setReceiptsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iotextypes.EpochData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iotextypes.EpochData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.iotextypes.EpochData.displayName = 'proto.iotextypes.EpochData';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iotextypes.EpochData.prototype.toObject = function(opt_includeInstance) {
  return proto.iotextypes.EpochData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iotextypes.EpochData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.EpochData.toObject = function(includeInstance, msg) {
  var f, obj = {
    num: jspb.Message.getFieldWithDefault(msg, 1, 0),
    height: jspb.Message.getFieldWithDefault(msg, 2, 0),
    gravitychainstartheight: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iotextypes.EpochData}
 */
proto.iotextypes.EpochData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iotextypes.EpochData;
  return proto.iotextypes.EpochData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iotextypes.EpochData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iotextypes.EpochData}
 */
proto.iotextypes.EpochData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setNum(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setHeight(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setGravitychainstartheight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iotextypes.EpochData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iotextypes.EpochData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iotextypes.EpochData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.EpochData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNum();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getGravitychainstartheight();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
};


/**
 * optional uint64 num = 1;
 * @return {number}
 */
proto.iotextypes.EpochData.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.iotextypes.EpochData.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 height = 2;
 * @return {number}
 */
proto.iotextypes.EpochData.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.iotextypes.EpochData.prototype.setHeight = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 gravityChainStartHeight = 3;
 * @return {number}
 */
proto.iotextypes.EpochData.prototype.getGravitychainstartheight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.iotextypes.EpochData.prototype.setGravitychainstartheight = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iotextypes.ChainMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iotextypes.ChainMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.iotextypes.ChainMeta.displayName = 'proto.iotextypes.ChainMeta';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iotextypes.ChainMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.iotextypes.ChainMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iotextypes.ChainMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.ChainMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
    height: jspb.Message.getFieldWithDefault(msg, 1, 0),
    numactions: jspb.Message.getFieldWithDefault(msg, 2, 0),
    tps: jspb.Message.getFieldWithDefault(msg, 3, 0),
    epoch: (f = msg.getEpoch()) && proto.iotextypes.EpochData.toObject(includeInstance, f),
    tpsfloat: +jspb.Message.getFieldWithDefault(msg, 5, 0.0),
    chainid: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iotextypes.ChainMeta}
 */
proto.iotextypes.ChainMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iotextypes.ChainMeta;
  return proto.iotextypes.ChainMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iotextypes.ChainMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iotextypes.ChainMeta}
 */
proto.iotextypes.ChainMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setHeight(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNumactions(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTps(value);
      break;
    case 4:
      var value = new proto.iotextypes.EpochData;
      reader.readMessage(value,proto.iotextypes.EpochData.deserializeBinaryFromReader);
      msg.setEpoch(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTpsfloat(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setChainid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iotextypes.ChainMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iotextypes.ChainMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iotextypes.ChainMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.ChainMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getNumactions();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTps();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getEpoch();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.iotextypes.EpochData.serializeBinaryToWriter
    );
  }
  f = message.getTpsfloat();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getChainid();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
};


/**
 * optional uint64 height = 1;
 * @return {number}
 */
proto.iotextypes.ChainMeta.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.iotextypes.ChainMeta.prototype.setHeight = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 numActions = 2;
 * @return {number}
 */
proto.iotextypes.ChainMeta.prototype.getNumactions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.iotextypes.ChainMeta.prototype.setNumactions = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 tps = 3;
 * @return {number}
 */
proto.iotextypes.ChainMeta.prototype.getTps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.iotextypes.ChainMeta.prototype.setTps = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional EpochData epoch = 4;
 * @return {?proto.iotextypes.EpochData}
 */
proto.iotextypes.ChainMeta.prototype.getEpoch = function() {
  return /** @type{?proto.iotextypes.EpochData} */ (
    jspb.Message.getWrapperField(this, proto.iotextypes.EpochData, 4));
};


/** @param {?proto.iotextypes.EpochData|undefined} value */
proto.iotextypes.ChainMeta.prototype.setEpoch = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.iotextypes.ChainMeta.prototype.clearEpoch = function() {
  this.setEpoch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.iotextypes.ChainMeta.prototype.hasEpoch = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float tpsFloat = 5;
 * @return {number}
 */
proto.iotextypes.ChainMeta.prototype.getTpsfloat = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 5, 0.0));
};


/** @param {number} value */
proto.iotextypes.ChainMeta.prototype.setTpsfloat = function(value) {
  jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional uint32 chainID = 6;
 * @return {number}
 */
proto.iotextypes.ChainMeta.prototype.getChainid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.iotextypes.ChainMeta.prototype.setChainid = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iotextypes.BlockMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iotextypes.BlockMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.iotextypes.BlockMeta.displayName = 'proto.iotextypes.BlockMeta';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iotextypes.BlockMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.iotextypes.BlockMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iotextypes.BlockMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    height: jspb.Message.getFieldWithDefault(msg, 2, 0),
    timestamp: (f = msg.getTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    numactions: jspb.Message.getFieldWithDefault(msg, 4, 0),
    produceraddress: jspb.Message.getFieldWithDefault(msg, 5, ""),
    transferamount: jspb.Message.getFieldWithDefault(msg, 6, ""),
    txroot: jspb.Message.getFieldWithDefault(msg, 7, ""),
    receiptroot: jspb.Message.getFieldWithDefault(msg, 8, ""),
    deltastatedigest: jspb.Message.getFieldWithDefault(msg, 9, ""),
    logsbloom: jspb.Message.getFieldWithDefault(msg, 10, ""),
    previousblockhash: jspb.Message.getFieldWithDefault(msg, 11, ""),
    gaslimit: jspb.Message.getFieldWithDefault(msg, 12, 0),
    gasused: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iotextypes.BlockMeta}
 */
proto.iotextypes.BlockMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iotextypes.BlockMeta;
  return proto.iotextypes.BlockMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iotextypes.BlockMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iotextypes.BlockMeta}
 */
proto.iotextypes.BlockMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setHeight(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNumactions(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProduceraddress(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransferamount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTxroot(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiptroot(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeltastatedigest(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogsbloom(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousblockhash(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setGaslimit(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setGasused(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iotextypes.BlockMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iotextypes.BlockMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNumactions();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getProduceraddress();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTransferamount();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTxroot();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getReceiptroot();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDeltastatedigest();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLogsbloom();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPreviousblockhash();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getGaslimit();
  if (f !== 0) {
    writer.writeUint64(
      12,
      f
    );
  }
  f = message.getGasused();
  if (f !== 0) {
    writer.writeUint64(
      13,
      f
    );
  }
};


/**
 * optional string hash = 1;
 * @return {string}
 */
proto.iotextypes.BlockMeta.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.iotextypes.BlockMeta.prototype.setHash = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 height = 2;
 * @return {number}
 */
proto.iotextypes.BlockMeta.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.iotextypes.BlockMeta.prototype.setHeight = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp timestamp = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.iotextypes.BlockMeta.prototype.getTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.iotextypes.BlockMeta.prototype.setTimestamp = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.iotextypes.BlockMeta.prototype.clearTimestamp = function() {
  this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.iotextypes.BlockMeta.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 numActions = 4;
 * @return {number}
 */
proto.iotextypes.BlockMeta.prototype.getNumactions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.iotextypes.BlockMeta.prototype.setNumactions = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string producerAddress = 5;
 * @return {string}
 */
proto.iotextypes.BlockMeta.prototype.getProduceraddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.iotextypes.BlockMeta.prototype.setProduceraddress = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string transferAmount = 6;
 * @return {string}
 */
proto.iotextypes.BlockMeta.prototype.getTransferamount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.iotextypes.BlockMeta.prototype.setTransferamount = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string txRoot = 7;
 * @return {string}
 */
proto.iotextypes.BlockMeta.prototype.getTxroot = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.iotextypes.BlockMeta.prototype.setTxroot = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string receiptRoot = 8;
 * @return {string}
 */
proto.iotextypes.BlockMeta.prototype.getReceiptroot = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.iotextypes.BlockMeta.prototype.setReceiptroot = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string deltaStateDigest = 9;
 * @return {string}
 */
proto.iotextypes.BlockMeta.prototype.getDeltastatedigest = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.iotextypes.BlockMeta.prototype.setDeltastatedigest = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string logsBloom = 10;
 * @return {string}
 */
proto.iotextypes.BlockMeta.prototype.getLogsbloom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.iotextypes.BlockMeta.prototype.setLogsbloom = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string previousBlockHash = 11;
 * @return {string}
 */
proto.iotextypes.BlockMeta.prototype.getPreviousblockhash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.iotextypes.BlockMeta.prototype.setPreviousblockhash = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional uint64 gasLimit = 12;
 * @return {number}
 */
proto.iotextypes.BlockMeta.prototype.getGaslimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.iotextypes.BlockMeta.prototype.setGaslimit = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional uint64 gasUsed = 13;
 * @return {number}
 */
proto.iotextypes.BlockMeta.prototype.getGasused = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.iotextypes.BlockMeta.prototype.setGasused = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iotextypes.BlockIdentifier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iotextypes.BlockIdentifier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.iotextypes.BlockIdentifier.displayName = 'proto.iotextypes.BlockIdentifier';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iotextypes.BlockIdentifier.prototype.toObject = function(opt_includeInstance) {
  return proto.iotextypes.BlockIdentifier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iotextypes.BlockIdentifier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockIdentifier.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    height: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iotextypes.BlockIdentifier}
 */
proto.iotextypes.BlockIdentifier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iotextypes.BlockIdentifier;
  return proto.iotextypes.BlockIdentifier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iotextypes.BlockIdentifier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iotextypes.BlockIdentifier}
 */
proto.iotextypes.BlockIdentifier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setHeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockIdentifier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iotextypes.BlockIdentifier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iotextypes.BlockIdentifier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockIdentifier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional string hash = 1;
 * @return {string}
 */
proto.iotextypes.BlockIdentifier.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.iotextypes.BlockIdentifier.prototype.setHash = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 height = 2;
 * @return {number}
 */
proto.iotextypes.BlockIdentifier.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.iotextypes.BlockIdentifier.prototype.setHeight = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iotextypes.AccountMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iotextypes.AccountMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.iotextypes.AccountMeta.displayName = 'proto.iotextypes.AccountMeta';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iotextypes.AccountMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.iotextypes.AccountMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iotextypes.AccountMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.AccountMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
    address: jspb.Message.getFieldWithDefault(msg, 1, ""),
    balance: jspb.Message.getFieldWithDefault(msg, 2, ""),
    nonce: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pendingnonce: jspb.Message.getFieldWithDefault(msg, 4, 0),
    numactions: jspb.Message.getFieldWithDefault(msg, 5, 0),
    iscontract: jspb.Message.getFieldWithDefault(msg, 6, false),
    contractbytecode: msg.getContractbytecode_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iotextypes.AccountMeta}
 */
proto.iotextypes.AccountMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iotextypes.AccountMeta;
  return proto.iotextypes.AccountMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iotextypes.AccountMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iotextypes.AccountMeta}
 */
proto.iotextypes.AccountMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBalance(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setNonce(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPendingnonce(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setNumactions(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscontract(value);
      break;
    case 7:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setContractbytecode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iotextypes.AccountMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iotextypes.AccountMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iotextypes.AccountMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.AccountMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBalance();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNonce();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getPendingnonce();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getNumactions();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getIscontract();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getContractbytecode_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      7,
      f
    );
  }
};


/**
 * optional string address = 1;
 * @return {string}
 */
proto.iotextypes.AccountMeta.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.iotextypes.AccountMeta.prototype.setAddress = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string balance = 2;
 * @return {string}
 */
proto.iotextypes.AccountMeta.prototype.getBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.iotextypes.AccountMeta.prototype.setBalance = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 nonce = 3;
 * @return {number}
 */
proto.iotextypes.AccountMeta.prototype.getNonce = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.iotextypes.AccountMeta.prototype.setNonce = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 pendingNonce = 4;
 * @return {number}
 */
proto.iotextypes.AccountMeta.prototype.getPendingnonce = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.iotextypes.AccountMeta.prototype.setPendingnonce = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 numActions = 5;
 * @return {number}
 */
proto.iotextypes.AccountMeta.prototype.getNumactions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.iotextypes.AccountMeta.prototype.setNumactions = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool isContract = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.iotextypes.AccountMeta.prototype.getIscontract = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.iotextypes.AccountMeta.prototype.setIscontract = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bytes contractByteCode = 7;
 * @return {string}
 */
proto.iotextypes.AccountMeta.prototype.getContractbytecode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * optional bytes contractByteCode = 7;
 * This is a type-conversion wrapper around `getContractbytecode()`
 * @return {string}
 */
proto.iotextypes.AccountMeta.prototype.getContractbytecode_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getContractbytecode()));
};


/**
 * optional bytes contractByteCode = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getContractbytecode()`
 * @return {!Uint8Array}
 */
proto.iotextypes.AccountMeta.prototype.getContractbytecode_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getContractbytecode()));
};


/** @param {!(string|Uint8Array)} value */
proto.iotextypes.AccountMeta.prototype.setContractbytecode = function(value) {
  jspb.Message.setProto3BytesField(this, 7, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iotextypes.BlockStore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.iotextypes.BlockStore.repeatedFields_, null);
};
goog.inherits(proto.iotextypes.BlockStore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.iotextypes.BlockStore.displayName = 'proto.iotextypes.BlockStore';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.iotextypes.BlockStore.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iotextypes.BlockStore.prototype.toObject = function(opt_includeInstance) {
  return proto.iotextypes.BlockStore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iotextypes.BlockStore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockStore.toObject = function(includeInstance, msg) {
  var f, obj = {
    block: (f = msg.getBlock()) && proto.iotextypes.Block.toObject(includeInstance, f),
    receiptsList: jspb.Message.toObjectList(msg.getReceiptsList(),
    proto_types_action_pb.Receipt.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iotextypes.BlockStore}
 */
proto.iotextypes.BlockStore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iotextypes.BlockStore;
  return proto.iotextypes.BlockStore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iotextypes.BlockStore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iotextypes.BlockStore}
 */
proto.iotextypes.BlockStore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.iotextypes.Block;
      reader.readMessage(value,proto.iotextypes.Block.deserializeBinaryFromReader);
      msg.setBlock(value);
      break;
    case 2:
      var value = new proto_types_action_pb.Receipt;
      reader.readMessage(value,proto_types_action_pb.Receipt.deserializeBinaryFromReader);
      msg.addReceipts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockStore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iotextypes.BlockStore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iotextypes.BlockStore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockStore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlock();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.iotextypes.Block.serializeBinaryToWriter
    );
  }
  f = message.getReceiptsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_types_action_pb.Receipt.serializeBinaryToWriter
    );
  }
};


/**
 * optional Block block = 1;
 * @return {?proto.iotextypes.Block}
 */
proto.iotextypes.BlockStore.prototype.getBlock = function() {
  return /** @type{?proto.iotextypes.Block} */ (
    jspb.Message.getWrapperField(this, proto.iotextypes.Block, 1));
};


/** @param {?proto.iotextypes.Block|undefined} value */
proto.iotextypes.BlockStore.prototype.setBlock = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.iotextypes.BlockStore.prototype.clearBlock = function() {
  this.setBlock(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.iotextypes.BlockStore.prototype.hasBlock = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Receipt receipts = 2;
 * @return {!Array<!proto.iotextypes.Receipt>}
 */
proto.iotextypes.BlockStore.prototype.getReceiptsList = function() {
  return /** @type{!Array<!proto.iotextypes.Receipt>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_types_action_pb.Receipt, 2));
};


/** @param {!Array<!proto.iotextypes.Receipt>} value */
proto.iotextypes.BlockStore.prototype.setReceiptsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.iotextypes.Receipt=} opt_value
 * @param {number=} opt_index
 * @return {!proto.iotextypes.Receipt}
 */
proto.iotextypes.BlockStore.prototype.addReceipts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.iotextypes.Receipt, opt_index);
};


proto.iotextypes.BlockStore.prototype.clearReceiptsList = function() {
  this.setReceiptsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iotextypes.BlockStores = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.iotextypes.BlockStores.repeatedFields_, null);
};
goog.inherits(proto.iotextypes.BlockStores, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.iotextypes.BlockStores.displayName = 'proto.iotextypes.BlockStores';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.iotextypes.BlockStores.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iotextypes.BlockStores.prototype.toObject = function(opt_includeInstance) {
  return proto.iotextypes.BlockStores.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iotextypes.BlockStores} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockStores.toObject = function(includeInstance, msg) {
  var f, obj = {
    blockstoresList: jspb.Message.toObjectList(msg.getBlockstoresList(),
    proto.iotextypes.BlockStore.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iotextypes.BlockStores}
 */
proto.iotextypes.BlockStores.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iotextypes.BlockStores;
  return proto.iotextypes.BlockStores.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iotextypes.BlockStores} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iotextypes.BlockStores}
 */
proto.iotextypes.BlockStores.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.iotextypes.BlockStore;
      reader.readMessage(value,proto.iotextypes.BlockStore.deserializeBinaryFromReader);
      msg.addBlockstores(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iotextypes.BlockStores.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iotextypes.BlockStores.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iotextypes.BlockStores} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iotextypes.BlockStores.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlockstoresList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.iotextypes.BlockStore.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BlockStore blockStores = 1;
 * @return {!Array<!proto.iotextypes.BlockStore>}
 */
proto.iotextypes.BlockStores.prototype.getBlockstoresList = function() {
  return /** @type{!Array<!proto.iotextypes.BlockStore>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.iotextypes.BlockStore, 1));
};


/** @param {!Array<!proto.iotextypes.BlockStore>} value */
proto.iotextypes.BlockStores.prototype.setBlockstoresList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.iotextypes.BlockStore=} opt_value
 * @param {number=} opt_index
 * @return {!proto.iotextypes.BlockStore}
 */
proto.iotextypes.BlockStores.prototype.addBlockstores = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.iotextypes.BlockStore, opt_index);
};


proto.iotextypes.BlockStores.prototype.clearBlockstoresList = function() {
  this.setBlockstoresList([]);
};


goog.object.extend(exports, proto.iotextypes);
